module.exports = { 
    s1:{
      th:{
         subject:"ส่วนที่ 1 : ประสบการณ์ในการเข้ารับบริการที่ศูนย์ซ่อมสีตัวถัง",
         subject_agent:"ส่วนที่ 1 : ประสบการณ์ในการเข้ารับบริการที่ศูนย์ซ่อมสีตัวถัง",
         descriptions:null,
         descriptions_agent:null,
      },
      en:{
         subject:"Part 1",
         subject_agent:"Part 1",
         descriptions:null,
         descriptions_agent:null,
      }
    },
    s2_1:{
      th:{
         subject:"ส่วนที่ 2 : ความพึงพอใจของท่านที่มีต่อการใช้บริการที่ศูนย์ซ่อมสีและตัวถัง",
         subject_agent:"ส่วนที่ 2 : ความพึงพอใจของท่านที่มีต่อการใช้บริการที่ศูนย์ซ่อมสีและตัวถัง",
         descriptions:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 0-10 โดยที่ 0 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 0 ถึง 10",
         descriptions_agent:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 0-10 โดยที่ 0 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 0 ถึง 10",
      },
      en:{
         subject:"Part 2",
         subject_agent:"Part 2",
         descriptions:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 0-10 โดยที่ 0 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 0 ถึง 10",
         descriptions_agent:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 0-10 โดยที่ 0 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 0 ถึง 10",
      },
    },
    s2_2:{
      th:{
         subject:"ส่วนที่ 2 : ความพึงพอใจของท่านที่มีต่อการใช้บริการที่ศูนย์ซ่อมสีและตัวถัง",
         subject_agent:"ส่วนที่ 2 : ความพึงพอใจของท่านที่มีต่อการใช้บริการที่ศูนย์ซ่อมสีและตัวถัง",
         descriptions:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 1-10 โดยที่ 1 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 1 ถึง 10",
         descriptions_agent:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 1-10 โดยที่ 1 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 1 ถึง 10",
      },
      en:{
         subject:"Part 2",
         subject_agent:"Part 2",
         descriptions:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 1-10 โดยที่ 1 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 1 ถึง 10",
         descriptions_agent:"กรุณาประเมินความพึงพอใจที่ท่านได้รับจากการบริการของศูนย์ซ่อมสีและตัวถังแห่งนี้ โดยใช้ระดับคะแนนความพึงพอใจจาก 1-10 โดยที่ 1 หมายถึง “ไม่พึงพอใจมากที่สุด” และ 10 หมายถึง “พึงพอใจมากที่สุด” ซึ่งท่านสามารถให้คะแนนเท่าไหร่ก็ได้ตั้งแต่ 1 ถึง 10",
      },
    },
    s3:{
       th:{
        subject:"ส่วนที่ 3",
        subject_agent:"ส่วนที่ 3",
        descriptions:null,
        descriptions_agent:null,
       },
       en:{
        subject:"Part 3",
        subject_agent:"Part 3",
        descriptions: null,
        descriptions_agent: null,
       },
    },
   //  s4:{
   //     th:{
   //      subject:"ส่วนที่ 4: ความผูกพันต่อบริษัทเอ็มโอแค็ป",
   //      descriptions:null,
   //     },
   //     en:{
   //      subject:"Part 4: Engagement towards MOCAP",
   //      descriptions:null,
   //     },
   //  },
};